import React, { useState } from "react";
import axios from "axios";
import { baseUrl } from "../Univ";
import { useParams } from "react-router-dom";

function UploadImages() {

  const { id } = useParams();
  const [image, setImage] = useState(null);

  const upload = async () => {

    const formData = new FormData();
    formData.append("product", id);
    formData.append("image", image);

    await axios.post(
      baseUrl + "upload-image/",
      formData,
      {
        headers:{
          Authorization:`Bearer ${localStorage.getItem("access")}`
        }
      }
    );

    alert("Uploaded");
  };

  return (
    <div className="container mt-4">

      <h3>Upload Product Image</h3>

      <input type="file" onChange={e=>setImage(e.target.files[0])}/>
      <br/><br/>
      <button className="btn btn-success" onClick={upload}>
        Upload
      </button>

    </div>
  );
}

export default UploadImages;
